import { Component, inject } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { CoreModule } from "@modules/core/core.module";
import { CustomerSegmentationModalComponent } from "@modules/uk-finprom/components/customer-segmentation/customer-segmentation.component";
import { CustomModal } from "@modules/core/components/base-modals";

@Component({
	selector: "start-customer-segmentation-modal",
	templateUrl: "./start-customer-segmentation-modal.component.html",
	styleUrls: ["./start-customer-segmentation-modal.component.scss"],
	standalone: true,
	imports: [CoreModule]
})
export class StartCustomerSegmentationModalComponent extends CustomModal {
	public readonly modalService = inject(ModalService);

	public confirm(): void {
		super.close();
		this.modalService
			.create(CustomerSegmentationModalComponent, null, {
				preventBackdropDismiss: true,
				preventEscDismiss: true
			})
			.present();
	}
}
